// Helper Functions
import pxToRem from 'assets/theme/functions/pxToRem';

export default {
  styleOverrides: {
    root: {
      padding: `${pxToRem(8)} ${pxToRem(10)}`,
      '&:last-child': {
        paddingBottom: pxToRem(10)
      }
    }
  }
};
